import React, { useEffect } from 'react';

import { GoogleAnalyticsEventType } from 'enums/GoogleAnalyticsEventType';
import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import useGoogleAnalytics from 'hooks/useGoogleAnalytics';
import LoaderStep from 'pages/CuroPages/ApplicationProcess/steps/LoaderStep';
import { gpsGatewayCheck, wellsFargoCheck } from 'thunks';

const SendApplicationForFundingStep = () => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const addDataLayersEvent = useGoogleAnalytics();

  const handleContinue = async () => {
    //CURO-TODO add logic;
    await dispatchWithUnwrap(gpsGatewayCheck());
    await dispatchWithUnwrap(wellsFargoCheck());
    addDataLayersEvent(GoogleAnalyticsEventType.FundedStatus);
  };

  useEffect(() => {
    handleContinue();
  }, []);

  return <LoaderStep />;
};

export default SendApplicationForFundingStep;
